import React from "react"
import styled from "styled-components"
import H5 from "@irati/ui/src/Headings/H5"
import {FormattedMessage} from "@irati/utils/lang"
import padding from "@irati/ui/src/global/padding"
import {Para} from "../../../ui/Labels"

const Heading = styled(H5)`
  margin: ${padding.medium} 0;
`

const NoData = () => (
  <>
    <Heading> <FormattedMessage id="insights.comments.table.empty.heading" /> </Heading>
    <Para> <FormattedMessage id="insights.comments.table.empty.text" />  </Para>
  </>
)

export default NoData
